import { render } from "./companyAddr.vue?vue&type=template&id=1a20dfbb&scoped=true"
import script from "./companyAddr.vue?vue&type=script&lang=js"
export * from "./companyAddr.vue?vue&type=script&lang=js"

import "./companyAddr.vue?vue&type=style&index=0&id=1a20dfbb&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-1a20dfbb"

export default script